"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSearchDataModel = void 0;
var _mergeDataModels = require("../../mergeDataModels");
var _searchDataModel = require("./searchDataModel");
const EMPTY_SEARCH_DATA_MODEL = {
  name: {
    givenName: "",
    surname: "",
    secondSurname: "",
    givenNameExactness: {
      flags: {
        phonetic: false,
        similar: false,
        initials: false
      },
      isExact: false
    },
    surnameExactness: {
      flags: {
        phonetic: false,
        similar: false,
        soundex: false
      },
      isExact: false
    }
  },
  events: {
    SelfBirth: {
      instances: [],
      relation: "Self",
      eventName: "Birth"
    },
    SelfMarriage: {
      instances: [],
      relation: "Self",
      eventName: "Marriage"
    },
    SelfDeath: {
      instances: [],
      relation: "Self",
      eventName: "Death"
    },
    SelfResidence: {
      instances: [],
      relation: "Self",
      eventName: "Residence"
    },
    SelfMilitary: {
      instances: [],
      relation: "Self",
      eventName: "Military"
    },
    SelfDeparture: {
      instances: [],
      relation: "Self",
      eventName: "Departure"
    },
    SelfArrival: {
      instances: [],
      relation: "Self",
      eventName: "Arrival"
    },
    SelfDivorce: {
      instances: [],
      relation: "Self",
      eventName: "Divorce"
    },
    Self: {
      instances: [],
      relation: "Self",
      eventName: ""
    }
  },
  family: {
    father: {
      instances: []
    },
    mother: {
      instances: []
    },
    parent: {
      instances: []
    },
    spouse: {
      instances: []
    },
    child: {
      instances: []
    },
    sibling: {
      instances: []
    }
  },
  priority: "default",
  location: [],
  types: {
    records: true,
    stories: true,
    trees: true,
    photos: true
  },
  page: {
    cursor: "",
    number: 1,
    size: 20
  },
  viewMode: "record",
  treePerson: {
    treeId: "",
    personId: ""
  },
  sort: "count",
  fields: {
    SelfRace: {
      value: "",
      relation: "Self",
      eventName: "",
      assertion: "Race",
      isExact: false
    },
    keyword: {
      value: "",
      relation: "",
      eventName: "",
      assertion: "keyword",
      isExact: false
    },
    SelfGender: {
      value: null,
      relation: "Self",
      eventName: "",
      assertion: "Gender",
      isExact: false
    }
  },
  searchType: "form",
  filters: {
    events: {
      SelfBirth: {
        date: {
          start: null,
          end: null
        },
        location: {
          gpid: ""
        }
      },
      SelfDeath: {
        date: {
          start: null,
          end: null
        },
        location: {
          gpid: ""
        }
      },
      SelfMarriage: {
        date: {
          start: null,
          end: null
        },
        location: {
          gpid: ""
        }
      },
      SelfResidence: {
        date: {
          start: null,
          end: null
        },
        location: {
          gpid: ""
        }
      },
      SelfArrival: {
        date: {
          start: null,
          end: null
        },
        location: {
          gpid: ""
        }
      },
      SelfDeparture: {
        date: {
          start: null,
          end: null
        },
        location: {
          gpid: ""
        }
      },
      SelfMilitary: {
        date: {
          start: null,
          end: null
        },
        location: {
          gpid: ""
        }
      }
    },
    record: {
      date: {
        start: null,
        end: null
      },
      location: {
        gpid: ""
      }
    },
    imageSubject: "",
    documentType: "",
    imageSource: "",
    facetsOnly: "",
    recordSubject: _searchDataModel.RecordSubject.All
  },
  debug: false,
  eventType: null,
  defaultFacets: [],
  showUnviewedRecordsOnly: false,
  useCanonicalUrl: false,
  searchMode: null,
  skipVeiling: false,
  include: "all",
  refinements: {
    requestType: "all",
    includeRefinements: []
  },
  shouldShowDocTabExperimentalFacets: false,
  options: {
    useYearRangeTaxonomies: false,
    reqOptimisationEnabled: false
  },
  passThroughData: "",
  parentCategory: "",
  timespan: {
    yearStart: null,
    yearEnd: null,
    matchMode: "rankOnly"
  }
};
const createSearchDataModel = (overrides = {}) => (0, _mergeDataModels.mergeDataModels)({}, EMPTY_SEARCH_DATA_MODEL, overrides);
exports.createSearchDataModel = createSearchDataModel;